import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { userReadHeaders } from '../lib/api';

const API = window.location.origin;

export function useWallet(userId) {
  const [balance, setBalance] = useState(null);
  const [ledger, setLedger] = useState([]);
  const [loading, setLoading] = useState(!!userId);
  const [error, setError] = useState(null);
  const [serverError, setServerError] = useState(false);
  const [tick, setTick] = useState(0);

  const refresh = useCallback(() => setTick(n => n + 1), []);

  useEffect(() => {
    const ctrl = new AbortController();

    async function load() {
      if (!userId) { setLoading(false); return; }
      setLoading(true);
      setError(null);

      const { data: { session } } = await supabase.auth.getSession();
      const token = session?.access_token;
      if (!token) { setLoading(false); return; }

      fetch(`${API}/api/wallet`, {
        headers: userReadHeaders(userId, token),
        signal: ctrl.signal,
      })
        .then(r => {
          if (!r.ok) {
            setServerError(r.status >= 500);
            throw new Error('Failed to load wallet');
          }
          setServerError(false);
          return r.json();
        })
        .then(data => { setBalance(data.balancePence); setLedger(data.ledger ?? []); })
        .catch(err => { if (err.name !== 'AbortError') setError(err.message); })
        .finally(() => setLoading(false));
    }

    load();
    return () => ctrl.abort();
  }, [userId, tick]);

  return { balance, ledger, loading, error, serverError, refresh };
}
